import { Controller } from "@hotwired/stimulus"

// Manages the delegated review card — unified form that switches action URL
export default class extends Controller {
  static targets = ["form", "notes", "notesLabel", "clarificationField", "submitBtn", "submitArea", "actionButtons", "payloadPanel", "emailSection", "emailFields", "sendEmailCheckbox", "emailMessage"]
  static values = { approveUrl: String, rejectUrl: String, clarifyUrl: String }

  selectAction(event) {
    const actionValue = event.currentTarget.dataset.reviewAction
    const showEmail = actionValue === "reject" || actionValue === "clarify"

    // Set form action URL and update labels
    if (actionValue === "approve") {
      this.formTarget.action = this.approveUrlValue
      this.notesLabelTarget.textContent = "Notes (optional)"
      this.notesTarget.placeholder = "Add any notes about this approval..."
      this.clarificationFieldTarget.classList.add("hidden")
      this.submitBtnTarget.textContent = "Approve & Apply"
    } else if (actionValue === "reject") {
      this.formTarget.action = this.rejectUrlValue
      this.notesLabelTarget.textContent = "Rejection reason"
      this.notesTarget.placeholder = "Explain why this is being rejected..."
      this.clarificationFieldTarget.classList.add("hidden")
      this.submitBtnTarget.textContent = "Reject & Notify"
    } else if (actionValue === "clarify") {
      this.formTarget.action = this.clarifyUrlValue
      this.notesLabelTarget.textContent = "Internal notes (optional)"
      this.notesTarget.placeholder = "Optional internal note..."
      this.clarificationFieldTarget.classList.remove("hidden")
      this.submitBtnTarget.textContent = "Request Clarification"
    }

    // Show/hide email section
    if (this.hasEmailSectionTarget) {
      if (showEmail) {
        this.emailSectionTarget.classList.remove("hidden")
      } else {
        this.emailSectionTarget.classList.add("hidden")
      }
    }

    this.actionButtonsTarget.classList.add("hidden")
    this.submitAreaTarget.classList.remove("hidden")
    this.formTarget.classList.remove("hidden")
  }

  reset() {
    this.actionButtonsTarget.classList.remove("hidden")
    this.submitAreaTarget.classList.add("hidden")
    this.formTarget.classList.add("hidden")
    this.clarificationFieldTarget.classList.add("hidden")
    if (this.hasEmailSectionTarget) this.emailSectionTarget.classList.add("hidden")
  }

  toggleEmailFields() {
    if (this.hasSendEmailCheckboxTarget && this.hasEmailFieldsTarget) {
      this.emailFieldsTarget.classList.toggle("hidden", !this.sendEmailCheckboxTarget.checked)
    }
  }

  submit(event) {
    event.preventDefault()
    this.formTarget.requestSubmit()
  }

  togglePayload() {
    this.payloadPanelTarget.classList.toggle("hidden")
  }
}
